import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareIssuetypesRoute: InvariantJiraRoute = {
	name: 'project-settings-software-issuetypes',
	path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId?',
	exact: true,
};
